import { MasterDialog } from "#common/Dialog/Dialog"
import { InputDate } from "#common/input/InputDate"
import { InputSelect } from "#common/input/InputSelect"
import { TextInfoField } from "#common/Texto"
import { useApiSend } from "#hooks/useApiSend"
import { Typography } from "@mui/material"
import TextField from "@mui/material/TextField"
import Grid2 from "@mui/material/Unstable_Grid2/Grid2"
import { bajaPost } from "Components/bajas/services/api"
import { BAJA_MOTIVO, NAME_COLLABORATOR, TYPE_BAJA } from "Components/bajas/TextBaja"
import { UseBajasTypes } from "Components/bajas/UseBajas"
import { useCallback, useMemo, useState } from "react"
import { TERMINATION_DATE } from "../../bajas/TextBaja"
import { UseDetalleColaboradorContext } from "../Solicitudes/SolicitudesContext"

/**
 *
 * @param {Object} props
 * @param {boolean} props.open - Indica si el dialogo se va a abrir o cerrar
 * @param {function} props.setOpen - Función para cambiar el estado de apertura del dialogo
 * @param {function} props.reloadNow - Función para actualizar la tabla de solicitudes
 * @param {Object} props.colaborador - Propiedades del colaborador que se va a solicitar
 * @returns
 */

export default function DialogSolicitudBaja({ reload, ...props }) {
	const { colaborador: boss, isRH } = UseDetalleColaboradorContext()
	const { open, setOpen } = props
	const nombre_completo = props?.colaborador?.nombre_completo
	const id = props?.colaborador?.id
	const { types } = UseBajasTypes({ disable: !open })
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		reload()
		setOpen(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch, cancelar } = useApiSend(bajaPost, { success, end })

	const [data, setData] = useState({
		collaborator: id,
		request: boss?.id,
		reason: "",
		motivo: "",
		termination_date: null,
		type: null,
	})

	const selectDate = (date) => {
		setData({ ...data, termination_date: date?.format("YYYY-MM-DD") })
	}

	const sendRequest = useCallback(() => {
		setDisabled(true)
		fetch(data)
	}, [data, fetch])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
					cancelar()
				},
			},
			{ label: "Enviar ", onClick: sendRequest, disabled },
		],
		[cancelar, disabled, sendRequest, setOpen]
	)

	return (
		<MasterDialog
			maxWidth="xs"
			{...props}
			title={
				<Typography variant="h5">
					<strong>Solicitud de baja</strong>
				</Typography>
			}
			buttons={buttons}
		>
			<Grid2 container spacing={2}>
				<Grid2 xs={12}>
					<TextInfoField
						campo={NAME_COLLABORATOR}
						valor={nombre_completo}
						whiteSpace="pre-line"
						separador={"\n"}
					/>
				</Grid2>
				<Grid2 xs={12}>
					<InputDate
						label={TERMINATION_DATE}
						onChange={selectDate}
						disablePast={!isRH}
					/>
				</Grid2>
				<Grid2 xs={12}>
					<InputSelect
						label={TYPE_BAJA}
						data={types}
						value={data.type}
						setValue={(d) => {
							setData({ ...data, type: d })
						}}
					/>
				</Grid2>
				<Grid2 xs={12}>
					<TextField
						id="bajaMotivo"
						label={BAJA_MOTIVO}
						variant="outlined"
						fullWidth
						multiline
						value={data.reason}
						onChange={(event) => {
							setData({ ...data, reason: event.target.value })
						}}
					/>
				</Grid2>
			</Grid2>
		</MasterDialog>
	)
}
